
export const GET_LIFECYCLES_PLATFORMS_REQUEST = "GET_LIFECYCLES_PLATFORMS_REQUEST";
export const GET_LIFECYCLES_PLATFORMS_SUCCESS = "GET_LIFECYCLES_PLATFORMS_SUCCESS";
export const GET_LIFECYCLES_PLATFORMS_FAILURE = "GET_LIFECYCLES_PLATFORMS_FAILURE";

export const GET_LIFECYCLES_PHASES_REQUEST = "GET_LIFECYCLES_PHASES_REQUEST";
export const GET_LIFECYCLES_PHASES_SUCCESS = "GET_LIFECYCLES_PHASES_SUCCESS";
export const GET_LIFECYCLES_PHASES_FAILURE = "GET_LIFECYCLES_PHASES_FAILURE";

export const SET_TARGET_DATE_REQUEST = 'SET_TARGET_DATE_REQUEST';
export const SET_TARGET_DATE_SUCCESS = 'SET_TARGET_DATE_SUCCESS';
export const SET_TARGET_DATE_FAILURE = 'SET_TARGET_DATE_FAILURE';

export const SET_LIFECYCLE_PLATFORMS = 'SET_LIFECYCLE_PLATFORMS';

export const GET_LIFECYLCE_TASKS_REQUEST = 'GET_LIFECYLCE_TASKS_REQUEST';
export const GET_LIFECYLCE_TASKS_SUCCESS = 'GET_LIFECYLCE_TASKS_SUCCESS';
export const GET_LIFECYLCE_TASKS_FAILURE = 'GET_LIFECYLCE_TASKS_FAILURE';

export const GET_LIFECYLCE_TASKS_FOR_USER_REQUEST = 'GET_LIFECYLCE_TASKS_FOR_USER_REQUEST';
export const GET_LIFECYLCE_TASKS_FOR_USER_SUCCESS = 'GET_LIFECYLCE_TASKS_FOR_USER_SUCCESS';
export const GET_LIFECYLCE_TASKS_FOR_USER_FAILURE = 'GET_LIFECYLCE_TASKS_FOR_USER_FAILURE';

export const CREATE_TASK_COMMENT_REQUEST = 'CREATE_TASK_COMMENT_REQUEST';
export const CREATE_TASK_COMMENT_SUCCESS = 'CREATE_TASK_COMMENT_SUCCESS';
export const CREATE_TASK_COMMENT_FAILURE = 'CREATE_TASK_COMMENT_FAILURE';

export const REMOVE_TASK_COMMENT_REQUEST = 'REMOVE_TASK_COMMENT_REQUEST';
export const REMOVE_TASK_COMMENT_SUCCESS = 'REMOVE_TASK_COMMENT_SUCCESS';
export const REMOVE_TASK_COMMENT_FAILURE = 'REMOVE_TASK_COMMENT_FAILURE';

export const EDIT_TASK_COMMENT_REQUEST = 'EDIT_TASK_COMMENT_REQUEST';
export const EDIT_TASK_COMMENT_SUCCESS = 'EDIT_TASK_COMMENT_SUCCESS';
export const EDIT_TASK_COMMENT_FAILURE = 'EDIT_TASK_COMMENT_FAILURE';

export const GET_TASK_TYPES_REQUEST = 'GET_TASK_TYPES_REQUEST';
export const GET_TASK_TYPES_SUCCESS = 'GET_TASK_TYPES_SUCCESS';
export const GET_TASK_TYPES_FAILURE = 'GET_TASK_TYPES_FAILURE';

export const CREATE_TASK_REQUEST = 'CREATE_TASK_REQUEST';
export const CREATE_TASK_SUCCESS = 'CREATE_TASK_SUCCESS';
export const CREATE_TASK_FAILURE = 'CREATE_TASK_FAILURE';

export const DELETE_TASK_REQUEST = 'DELETE_TASK_REQUEST';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const DELETE_TASK_FAILURE = 'DELETE_TASK_FAILURE';

export const EDIT_TASK_REQUEST = 'EDIT_TASK_REQUEST';
export const EDIT_TASK_SUCCESS = 'EDIT_TASK_SUCCESS';
export const EDIT_TASK_FAILURE = 'EDIT_TASK_FAILURE';

export const ASSIGN_TASK_REQUEST = 'ASSIGN_TASK_REQUEST';
export const ASSIGN_TASK_SUCCESS = 'ASSIGN_TASK_SUCCESS';
export const ASSIGN_TASK_FAILURE = 'ASSIGN_TASK_FAILURE';
